import LeftBorder, { LeftBorderProps } from './LeftBorder';

export type { LeftBorderProps };
export default LeftBorder;
